import React, { useRef, useState } from "react";
import { useEffect } from "react";
import HotelPricesTable from "./table/table";

const Price = ({ model, setModel }) => {
  const [data, setData] = useState([]);
  const oldPricesRef = useRef(model.prices);
  const calculateAdditionalFees = (fees) =>
    fees?.reduce((total, fee) => total + fee.cost, 0) || 0;

  const calculateBaseCost = (packageCosts) =>
    packageCosts?.reduce(
      (total, cost) => total + cost.cost * cost.exchange,
      0
    ) || 0;

  const createPrices = (destinations) => {
    const additionalFees = calculateAdditionalFees(model.differentFees);
    const baseCost = calculateBaseCost(model.packageUmrahCosts);

    const makkahDestinations = destinations.filter((d) => d.name === "makkah");
    const madinahDestinations = destinations.filter(
      (d) => d.name === "madinah"
    );

    const newPrices = [];

    madinahDestinations.forEach((madinah) => {
      madinah.hotelsUmrah.forEach((hotelMadinah) => {
        hotelMadinah.arrangements.forEach((arrMadinah) => {
          makkahDestinations.forEach((makkah) => {
            makkah.hotelsUmrah.forEach((hotelMakkah) => {
              hotelMakkah.arrangements.forEach((arrMakkah) => {
                if (
                  arrMadinah.designation === arrMakkah.designation &&
                  arrMadinah.typeTraveler === arrMakkah.typeTraveler
                ) {
                  const oldPrice =
                    oldPricesRef.current.find(
                      (price) =>
                        price.hotelMadinahName === hotelMadinah.name &&
                        price.hotelMakkahName === hotelMakkah.name &&
                        price.arrangementMadinahDesignation ===
                          arrMadinah.designation &&
                        price.arrangementMakkahDesignation ===
                          arrMakkah.designation &&
                        price.typeTraveler === arrMakkah.typeTraveler
                    ) || null;

                  const price = calculatePrice(
                    additionalFees,
                    baseCost,
                    hotelMadinah,
                    hotelMakkah,
                    arrMadinah,
                    arrMakkah,
                    oldPrice
                  );

                  newPrices.push(price);
                }
              });
            });
          });
        });
      });
    });

    return newPrices;
  };

  const calculatePrice = (
    additionalFees,
    baseCost,
    hotelMadinah,
    hotelMakkah,
    arrMadinah,
    arrMakkah,
    oldPrice
  ) => {
    const baseCostWithHotels =
      additionalFees +
      baseCost +
      arrMadinah.unitCost * hotelMadinah.duration * hotelMadinah.exchange +
      arrMakkah.unitCost * hotelMakkah.duration * hotelMakkah.exchange;

    let finalCost = baseCostWithHotels;

    if (model.nbr_for_free_place) {
      finalCost *= 1 + 1 / model.nbr_for_free_place;
    }

    return {
      typeTraveler: arrMakkah.typeTraveler,
      baseCost: finalCost,
      hotelMadinahName: hotelMadinah.name,
      hotelMakkahName: hotelMakkah.name,
      arrangementMadinahDesignation: arrMadinah.designation,
      arrangementMakkahDesignation: arrMakkah.designation,
      price: oldPrice?.price || 0,
      id: oldPrice?.id || 0,
      packageUmrahId: oldPrice?.packageUmrahId || 0,
      hotelMadinahId: oldPrice?.hotelMadinahId || 0,
      hotelMakkahId: oldPrice?.hotelMakkahId || 0,
    };
  };

  const groupPricesBy = (prices) => {
    const grouped = prices.reduce((acc, price) => {
      const key = `${price.hotelMakkahName} - ${price.hotelMadinahName} - ${price.typeTraveler}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(price);
      return acc;
    }, {});

    setData(grouped);
  };
  useEffect(() => {
    const prices = createPrices(model.destinations);
    if (prices.length) groupPricesBy(prices);
    setModel((prev) => ({ ...prev, prices }));
    oldPricesRef.current = prices;
  }, [model.destinations]);

  return (
    <div className="p-10">
      <HotelPricesTable
        model={model}
        data={data}
        setModel={setModel}
        grouppedBy={groupPricesBy}
      />
    </div>
  );
};

export default Price;
